<template>
  <transition :name="transitionName">
    <div class="ui-popup-picker-wrapper" v-show="value" @click.stop.self="handleClickMask">
      <div class="content">
        <slot></slot>
        <i class="icon icon-close" v-show="showClose" @click.stop.self="handleClose"></i>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "uiDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    transitionName: {
      type: String,
      default: "fade"
    }
  },
  methods: {
    handleClose() {
      this.$emit("input", false)
    },
    handleClickMask() {
      if (this.closeOnClickModal) {
        this.handleClose()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-popup-picker-wrapper {
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  .content {
    position: relative;
    background: #ffffff;
    border-radius: 20px;
    .icon-close {
      cursor: pointer;
      position: absolute;
      top: 23px;
      right: 23px;
      display: inline-block;
      width: 32px;
      height: 32px;
      background: url("./images/icon_delete.png") no-repeat center;
      background-size: 75%;
    }
  }
}
.fade-enter,
.fade-leave-to {
  background: rgba(0, 0, 0, 0);
  .content {
    transform: translate3d(0, -100px, 0);
    opacity: 0;
  }
}
.fade-enter-to,
.fade-leave {
  background: rgba(0, 0, 0, 0.5);
  .content {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
  .content {
    transition: all 0.3s;
  }
}
</style>
